
import React, { Component} from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { YellowButton } from 'ui/Button';


const StyledPage = styled.div`
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background:
    radial-gradient(circle at 12% 18%, rgba(254, 193, 8, 0.28), transparent 42%),
    radial-gradient(circle at 88% 78%, rgba(254, 193, 8, 0.16), transparent 36%),
    #fbfbfb;
`;

const Card = styled.div`
  width: 100%;
  max-width: 520px;
  text-align: center;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(51, 51, 51, 0.08);
  padding: 48px 40px 40px;
`;

const Code = styled.div`
  margin: 0 0 8px;
  font-size: 96px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: -4px;
  color: #333333;
`;

const Title = styled.h1`
  margin: 0 0 12px;
  font-size: 28px;
  font-weight: 500;
  color: #333333;
`;

const Text = styled.p`
  margin: 0 0 28px;
  font-size: 16px;
  line-height: 1.5;
  color: #828282;
`;


export default class PageNotFound extends Component {
  render() {
    return (
      <StyledPage>
        <Card>
          <Code>404</Code>
          <Title>Страница не найдена</Title>
          <Text>
            Такой страницы нет или она была перемещена.
            Проверьте адрес или вернитесь к перевозкам.
          </Text>
          <YellowButton component={Link} to="/order" size="large">
            На главную
          </YellowButton>
        </Card>
      </StyledPage>
    )
  }
}
